import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import noDataImg from '@/assets/images/noData.svg'
import poolHeader from '@/assets/images/pool-header.png'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { CommonFooter } from '@/components/layout'

// Mock data matching Vue implementation
const MOCK = {
  depositVolume: '10,136,518',
  annualizedRate: '4.39',
  token1: 'EOS',
  token2: 'sEOS',
  swapPrice: '0.301865',
}

export function VaultPage() {
  const { t } = useTranslation()
  const { isMobile } = useBreakpoint()
  const [activeTab, setActiveTab] = useState<'deposit' | 'withdraw'>('deposit')

  return (
    <div className="w-full flex justify-center px-4 md:px-[32px] md:mt-[32px]">
      <div className="w-full max-w-[400px]">
        {/* Header image */}
        {!isMobile && (
          <div className="flex justify-center">
            <img src={poolHeader} className="w-[129px]" alt="" />
          </div>
        )}

        {/* Action Card */}
        <div className="bg-white rounded-[26px] shadow-[0_0_8px_1px_rgba(61,98,50,0.14)] px-[16px] py-[24px]">
          {/* Tabs */}
          <div className="flex gap-[16px] mb-[20px] border-b border-[#ddf5ff] pb-[16px]">
            <button
              onClick={() => setActiveTab('deposit')}
              className={`text-[15px] font-semibold cursor-pointer pb-[4px] ${activeTab === 'deposit' ? 'text-[#498846] border-b-2 border-[#498846]' : 'text-[#999]'}`}
            >
              {t('vault.deposit')}
            </button>
            <button
              onClick={() => setActiveTab('withdraw')}
              className={`text-[15px] font-semibold cursor-pointer pb-[4px] ${activeTab === 'withdraw' ? 'text-[#498846] border-b-2 border-[#498846]' : 'text-[#999]'}`}
            >
              {t('vault.withdraw')}
            </button>
          </div>

          {/* Coming soon content */}
          <div className="flex flex-col items-center py-[40px]">
            <img src={noDataImg} className="w-[120px] mb-[12px]" alt="" />
            <span className="text-[14px] text-[#999]">Coming soon</span>
          </div>
        </div>

        {/* Overview Card */}
        <div className="mt-[30px] bg-white rounded-[26px] shadow-[0_0_8px_1px_rgba(61,98,50,0.14)] px-[16px] py-[24px]">
          <h3 className="text-[16px] font-bold text-foreground mb-[16px]">{t('vault.overview')}</h3>

          <div className="text-[13px] space-y-[8px]">
            <div className="flex items-center justify-between leading-[20px]">
              <span className="text-[#666]">{t('vault.totalValue')}</span>
              <span className="text-[#333] font-semibold">${MOCK.depositVolume}</span>
            </div>
            <div className="flex items-center justify-between leading-[20px]">
              <span className="text-[#666]">{t('vault.apy')}</span>
              <span className="text-[#498846] font-semibold">{MOCK.annualizedRate}%</span>
            </div>
            <div className="flex items-center justify-between leading-[20px]">
              <span className="text-[#666]">{t('public.price')}</span>
              <span className="text-[#333]">1 {MOCK.token1} ≈ {MOCK.swapPrice} {MOCK.token2}</span>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  )
}
